// extracted by mini-css-extract-plugin
module.exports = {"root":"m-multiplex___KHVS_tK"};